import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ic-driver",
  "use": "icon-ic-driver-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-ic-driver\"><path d=\"M8 1a4 4 0 0 1 2.982 6.666A6.998 6.998 0 0 1 15 14a1 1 0 0 1-2 0 5 5 0 0 0-10 0 1 1 0 0 1-2 0 7 7 0 0 1 4.018-6.335A4 4 0 0 1 8 1zm0 2a2 2 0 1 0 0 4 2 2 0 0 0 0-4z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol